
import { defineComponent } from 'vue'
import Dropdown from 'primevue/dropdown'
import Editor from 'primevue/editor'
import documentExecutionNotesDialogDescriptor from './DocumentExecutionNotesDialogDescriptor.json'

export default defineComponent({
    name: 'document-execution-notes-form',
    components: { Dropdown, Editor },
    props: { datasets: { type: Array }, selectedNote: { type: Object } },
    emits: ['selected'],
    data() {
        return {
            documentExecutionNotesDialogDescriptor,
            note: {} as any
        }
    },
    watch: {
        selectedNote() {
            this.loadNote()
        }
    },
    created() {
        this.loadNote()
    },
    methods: {
        loadNote() {
            this.note = this.selectedNote
        }
    }
})
